import ReactAppController from "./react_app_controller"

export default class extends ReactAppController {
  constructor(props) {
    super(props)
    this.name = "cameras_os_evolution_app_controller"
  }

  renderApp() {
    const appConfig = {
      buildingHandle: this.element.getAttribute("data-building-handle"),
      locale: this.element.getAttribute("data-locale")
    }
    // createRoot().render() doesn't clear existing children, so mounting over
    // a stale tree (restored Turbo snapshot, re-connect) duplicates the UI.
    this.element.replaceChildren()
    this.app = __bmx__initCamerasApp(this.element, appConfig)
  }
}
